import React from 'react';

type ChevronRightIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
  size = 20,
  color = '#999',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9 6l6 6-6 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronRightIcon;
